module.exports = __webpack_public_path__ + "img/dominik.78e74261.jpg";